import Button$1 from '@material-ui/core/Button';
import React__default from 'react';
import { Link } from '../Link/Link.esm.js';

const LinkWrapper = React__default.forwardRef((props, ref) => /* @__PURE__ */ React__default.createElement(Link, { ref, ...props, color: "initial" }));
const LinkButton = React__default.forwardRef(
  (props, ref) => /* @__PURE__ */ React__default.createElement(Button$1, { ref, component: LinkWrapper, ...props })
);
const Button = LinkButton;

export { Button, LinkButton };
//# sourceMappingURL=LinkButton.esm.js.map
